export interface Step {
  num: string;
  icon: string;
  title: string;
  text: string;
}

export const STEPS: Step[] = [
  {
    num: '1',
    icon: '📲',
    title: 'Откройте бота',
    text: 'Нажмите кнопку выше, перейдите в @vocal_cut_bot и запустите бота.',
  },
  {
    num: '2',
    icon: '🎧',
    title: 'Отправьте файл или ссылку',
    text: 'Пришлите боту аудио, видео или ссылку с YouTube/Rutube — можете не выгружать на компьютер.',
  },
  {
    num: '3',
    icon: '✨',
    title: 'Получите минус и рингтоны',
    text: 'За считанные минуты бот вернёт чистый инструментал плюс готовые рингтоны для Android и iOS.',
  },
];
